import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RosterContent } from '../../../types/roster-content';
import { RosterEventComponent } from '../../../roster.shared';
import { InPipe } from '@softline/ui-core';
import { RosterService } from '../../../services/roster.service';
import { PmsTaskDragCardComponent } from '../../pms-task-drag-card/pms-task-drag-card.component';

@Component({
  selector: 'soft-pms-event',
  imports: [CommonModule, InPipe, PmsTaskDragCardComponent],
  templateUrl: './pms-event.component.html',
  styleUrl: './pms-event.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PmsEventComponent implements RosterEventComponent<RosterContent> {
  protected readonly service = inject(RosterService);

  readonly event = input.required<RosterContent>();

  readonly eventType = computed(() => {
    console.log(this.event());
    if (this.event()?.original?.['additionalData']?.type === 'PLAN') {
      return 'PLAN';
    } else {
      return 'absence';
    }
  });
}
